module.exports = __webpack_public_path__ + "img/billing_summary.0b6adb48.svg";